import cn from "@/v2-ui/utils/utils.cn"

export type DiffMiniLineProps = {
  side: "old" | "new"
  text: string
}

/**
 * One line of a diff squeezed into a table cell: the −/+ sign and the text
 * truncated to a single line. The expanded row shows the word-level version.
 *
 * Same colours and sign gutter as DiffLine, so a cell previews the diff the
 * operator will see when they open the row.
 */
function DiffMiniLine(props: DiffMiniLineProps) {
  const { side, text } = props
  return (
    <span
      className={cn(
        "diff-mini",
        side === "old" ? "diff-mini-del" : "diff-mini-add",
      )}
      title={text}
    >
      <span className="diff-line-sign">{side === "old" ? "−" : "+"}</span>
      <span className="truncate">
        {text || <span className="italic">(empty)</span>}
      </span>
    </span>
  )
}

export default DiffMiniLine
